var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyInformation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 1277,
    height: 427,
    "aria-labelledby": titleId,
    viewBox: "0 0 1277 427",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "loading-aria"
  }, "Loading...") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "loading-aria"
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    clipPath: "url(#clip-path)",
    style: {
      fill: "url(\"#fill\")"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 0,
    rx: 3,
    ry: 3,
    width: 397,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 50,
    rx: 3,
    ry: 3,
    width: 245,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357,
    y: 15,
    rx: 3,
    ry: 3,
    width: 120,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9,
    rx: 0,
    ry: 0,
    width: 78,
    height: 54
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 93,
    rx: 0,
    ry: 0,
    width: 261,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 141,
    rx: 5,
    ry: 5,
    width: 125,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 165,
    rx: 0,
    ry: 0,
    width: 1277,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 194,
    rx: 0,
    ry: 0,
    width: 1277,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 225,
    rx: 0,
    ry: 0,
    width: 650,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 255,
    rx: 5,
    ry: 5,
    width: 165,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 280,
    rx: 0,
    ry: 0,
    width: 95,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 280,
    rx: 0,
    ry: 0,
    width: 95,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 280,
    rx: 0,
    ry: 0,
    width: 95,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315,
    y: 280,
    rx: 0,
    ry: 0,
    width: 95,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 280,
    rx: 0,
    ry: 0,
    width: 95,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 310,
    rx: 5,
    ry: 5,
    width: 165,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 335,
    rx: 10,
    ry: 10,
    width: 130,
    height: 31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 335,
    rx: 10,
    ry: 10,
    width: 150,
    height: 31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299,
    y: 335,
    rx: 10,
    ry: 10,
    width: 125,
    height: 31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 335,
    rx: 10,
    ry: 10,
    width: 155,
    height: 31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1117,
    cy: 28,
    r: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1143,
    y: 14,
    rx: 5,
    ry: 5,
    width: 130,
    height: 26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fill"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.599964,
    stopColor: "#f3f3f3",
    stopOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "-2; -2; 1",
    keyTimes: "0; 0.25; 1",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 1.59996,
    stopColor: "#96abba",
    stopOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "-1; -1; 2",
    keyTimes: "0; 0.25; 1",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 2.59996,
    stopColor: "#f3f3f3",
    stopOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "0; 0; 3",
    keyTimes: "0; 0.25; 1",
    dur: "2s",
    repeatCount: "indefinite"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyInformation);
export default __webpack_public_path__ + "static/media/company_information.c5e80f672c0668c6fd8913cd00ae06b5.svg";
export { ForwardRef as ReactComponent };